/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';

import type {
    APIErrorResponseResponse,
    AddEditIntegrationBodyBody,
    AddEditVenueIntegrationBodyBody,
    BatchPricingBodyBody,
    BatchPricingSuccessResponseResponse,
    DynamicPricingFeedSuccessResponseResponse,
    ExpediaAvailabilityResponse,
    ExpediaCommitSaleCancellationResponse,
    ExpediaCommitSaleRequest,
    ExpediaCommitSaleResponse,
    ExpediaCreateSaleCancellationRequest,
    ExpediaCreateSaleCancellationResponse,
    ExpediaCreateSaleRequest,
    ExpediaCreateSaleResponse,
    ExpediaGetAvailabilityParams,
    ExpediaGetSaleResponse,
    ExpediaReleaseSaleCancellationResponse,
    ExpediaReleaseSaleResponse,
    GetDynamicPricingFeedParams,
    GetIntegrationsParams,
    IntegrationSuccessResponseResponse,
    IntegrationsSuccessResponseResponse,
    SetDynamicPricingPricesBodyBody,
    SetDynamicPricingPricesSuccessResponseResponse,
    ViatorAvailabilityCheckBodyBody,
    ViatorAvailabilityCheckSuccessResponseResponse,
    ViatorBatchAvailabilityBodyBody,
    ViatorBatchAvailabilitySuccessResponseResponse,
    ViatorBookingAmendmentBodyBody,
    ViatorBookingAmendmentSuccessResponseResponse,
    ViatorBookingBodyBody,
    ViatorBookingCancellationBodyBody,
    ViatorBookingCancellationSuccessResponseResponse,
    ViatorBookingSuccessResponseResponse,
    ViatorTourListBodyBody,
    ViatorTourListSuccessResponseResponse,
} from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Get integrations matching the filters
 */
export const getIntegrations = (params?: GetIntegrationsParams, signal?: AbortSignal) => {
    return customInstance<IntegrationsSuccessResponseResponse>({
        url: `/integrations`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetIntegrationsQueryKey = (params?: GetIntegrationsParams) => {
    return [`/integrations`, ...(params ? [params] : [])] as const;
};

export const getGetIntegrationsQueryOptions = <
    TData = Awaited<ReturnType<typeof getIntegrations>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetIntegrationsParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getIntegrations>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetIntegrationsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrations>>> = ({ signal }) =>
        getIntegrations(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getIntegrations>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetIntegrationsQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrations>>>;
export type GetIntegrationsQueryError = APIErrorResponseResponse;

/**
 * @summary Get integrations matching the filters
 */

export function useGetIntegrations<
    TData = Awaited<ReturnType<typeof getIntegrations>>,
    TError = APIErrorResponseResponse,
>(
    params?: GetIntegrationsParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getIntegrations>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetIntegrationsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Create or update integration (upsert based on showId and type)
 */
export const editIntegration = (addEditIntegrationBodyBody: AddEditIntegrationBodyBody) => {
    return customInstance<IntegrationSuccessResponseResponse>({
        url: `/integrations`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: addEditIntegrationBodyBody,
    });
};

export const getEditIntegrationMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editIntegration>>,
        TError,
        { data: AddEditIntegrationBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editIntegration>>,
    TError,
    { data: AddEditIntegrationBodyBody },
    TContext
> => {
    const mutationKey = ['editIntegration'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editIntegration>>,
        { data: AddEditIntegrationBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return editIntegration(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditIntegrationMutationResult = NonNullable<
    Awaited<ReturnType<typeof editIntegration>>
>;
export type EditIntegrationMutationBody = AddEditIntegrationBodyBody;
export type EditIntegrationMutationError = APIErrorResponseResponse;

/**
 * @summary Create or update integration (upsert based on showId and type)
 */
export const useEditIntegration = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editIntegration>>,
        TError,
        { data: AddEditIntegrationBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editIntegration>>,
    TError,
    { data: AddEditIntegrationBodyBody },
    TContext
> => {
    const mutationOptions = getEditIntegrationMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get integration by id
 */
export const getIntegration = (id: number, signal?: AbortSignal) => {
    return customInstance<IntegrationSuccessResponseResponse>({
        url: `/integrations/${id}`,
        method: 'GET',
        signal,
    });
};

export const getGetIntegrationQueryKey = (id?: number) => {
    return [`/integrations/${id}`] as const;
};

export const getGetIntegrationQueryOptions = <
    TData = Awaited<ReturnType<typeof getIntegration>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getIntegration>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetIntegrationQueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegration>>> = ({ signal }) =>
        getIntegration(id, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getIntegration>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetIntegrationQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegration>>>;
export type GetIntegrationQueryError = APIErrorResponseResponse;

/**
 * @summary Get integration by id
 */

export function useGetIntegration<
    TData = Awaited<ReturnType<typeof getIntegration>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getIntegration>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetIntegrationQueryOptions(id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * @summary Create or update a venue-level integration (upsert based on venueId and type)
 */
export const editVenueIntegration = (
    id: number,
    addEditVenueIntegrationBodyBody: AddEditVenueIntegrationBodyBody,
) => {
    return customInstance<IntegrationSuccessResponseResponse>({
        url: `/venues/${id}/integrations`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: addEditVenueIntegrationBodyBody,
    });
};

export const getEditVenueIntegrationMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editVenueIntegration>>,
        TError,
        { id: number; data: AddEditVenueIntegrationBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof editVenueIntegration>>,
    TError,
    { id: number; data: AddEditVenueIntegrationBodyBody },
    TContext
> => {
    const mutationKey = ['editVenueIntegration'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof editVenueIntegration>>,
        { id: number; data: AddEditVenueIntegrationBodyBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return editVenueIntegration(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type EditVenueIntegrationMutationResult = NonNullable<
    Awaited<ReturnType<typeof editVenueIntegration>>
>;
export type EditVenueIntegrationMutationBody = AddEditVenueIntegrationBodyBody;
export type EditVenueIntegrationMutationError = APIErrorResponseResponse;

/**
 * @summary Create or update a venue-level integration (upsert based on venueId and type)
 */
export const useEditVenueIntegration = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof editVenueIntegration>>,
        TError,
        { id: number; data: AddEditVenueIntegrationBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof editVenueIntegration>>,
    TError,
    { id: number; data: AddEditVenueIntegrationBodyBody },
    TContext
> => {
    const mutationOptions = getEditVenueIntegrationMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Authenticated with the API key issued to the venue's dynamic-pricing integration. Lists sellable timeslots across the venue's shows with their remaining seat count and current price per ticket type/option combo (the manual TimeslotPrices override or the show's default price — never a previously pushed dynamic price), so the provider can compute new prices from a stable baseline. startTimeFrom/startTimeTo filter by timeslot start time; when both are omitted, every timeslot is returned regardless of start time.
 * @summary Dynamic-pricing provider feed: timeslots, availability, and current prices for a venue
 */
export const getDynamicPricingFeed = (
    id: number,
    params?: GetDynamicPricingFeedParams,
    signal?: AbortSignal,
) => {
    return customInstance<DynamicPricingFeedSuccessResponseResponse>({
        url: `/venues/${id}/dynamic-pricing/feed`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetDynamicPricingFeedQueryKey = (
    id?: number,
    params?: GetDynamicPricingFeedParams,
) => {
    return [`/venues/${id}/dynamic-pricing/feed`, ...(params ? [params] : [])] as const;
};

export const getGetDynamicPricingFeedQueryOptions = <
    TData = Awaited<ReturnType<typeof getDynamicPricingFeed>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    params?: GetDynamicPricingFeedParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getDynamicPricingFeed>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetDynamicPricingFeedQueryKey(id, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDynamicPricingFeed>>> = ({
        signal,
    }) => getDynamicPricingFeed(id, params, signal);

    return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getDynamicPricingFeed>>,
        TError,
        TData
    > & { queryKey: QueryKey };
};

export type GetDynamicPricingFeedQueryResult = NonNullable<
    Awaited<ReturnType<typeof getDynamicPricingFeed>>
>;
export type GetDynamicPricingFeedQueryError = APIErrorResponseResponse;

/**
 * @summary Dynamic-pricing provider feed: timeslots, availability, and current prices for a venue
 */

export function useGetDynamicPricingFeed<
    TData = Awaited<ReturnType<typeof getDynamicPricingFeed>>,
    TError = APIErrorResponseResponse,
>(
    id: number,
    params?: GetDynamicPricingFeedParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof getDynamicPricingFeed>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getGetDynamicPricingFeedQueryOptions(id, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * Authenticated with the API key issued to the venue's dynamic-pricing integration. For each timeslot in the request, replaces all of that timeslot's live pushed prices with the given set (1-day expiry). A manually-set TimeslotPrices override for a combo always wins over a pushed price for the same combo.
 * @summary Dynamic-pricing provider push: set prices for one or more timeslots
 */
export const setDynamicPricingPrices = (
    id: number,
    setDynamicPricingPricesBodyBody: SetDynamicPricingPricesBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<SetDynamicPricingPricesSuccessResponseResponse>({
        url: `/venues/${id}/dynamic-pricing/prices`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: setDynamicPricingPricesBodyBody,
        signal,
    });
};

export const getSetDynamicPricingPricesMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof setDynamicPricingPrices>>,
        TError,
        { id: number; data: SetDynamicPricingPricesBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof setDynamicPricingPrices>>,
    TError,
    { id: number; data: SetDynamicPricingPricesBodyBody },
    TContext
> => {
    const mutationKey = ['setDynamicPricingPrices'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof setDynamicPricingPrices>>,
        { id: number; data: SetDynamicPricingPricesBodyBody }
    > = (props) => {
        const { id, data } = props ?? {};

        return setDynamicPricingPrices(id, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type SetDynamicPricingPricesMutationResult = NonNullable<
    Awaited<ReturnType<typeof setDynamicPricingPrices>>
>;
export type SetDynamicPricingPricesMutationBody = SetDynamicPricingPricesBodyBody;
export type SetDynamicPricingPricesMutationError = APIErrorResponseResponse;

/**
 * @summary Dynamic-pricing provider push: set prices for one or more timeslots
 */
export const useSetDynamicPricingPrices = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof setDynamicPricingPrices>>,
        TError,
        { id: number; data: SetDynamicPricingPricesBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof setDynamicPricingPrices>>,
    TError,
    { id: number; data: SetDynamicPricingPricesBodyBody },
    TContext
> => {
    const mutationOptions = getSetDynamicPricingPricesMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Return products and product options, including v2 productOptionId for each sellable option.
 * @summary Viator Tour List (v1)
 */
export const viatorTourList = (
    viatorTourListBodyBody: ViatorTourListBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<ViatorTourListSuccessResponseResponse>({
        url: `/integrations/viator/tourlist`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: viatorTourListBodyBody,
        signal,
    });
};

export const getViatorTourListMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof viatorTourList>>,
        TError,
        { data: ViatorTourListBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof viatorTourList>>,
    TError,
    { data: ViatorTourListBodyBody },
    TContext
> => {
    const mutationKey = ['viatorTourList'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof viatorTourList>>,
        { data: ViatorTourListBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return viatorTourList(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ViatorTourListMutationResult = NonNullable<Awaited<ReturnType<typeof viatorTourList>>>;
export type ViatorTourListMutationBody = ViatorTourListBodyBody;
export type ViatorTourListMutationError = APIErrorResponseResponse;

/**
 * @summary Viator Tour List (v1)
 */
export const useViatorTourList = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof viatorTourList>>,
        TError,
        { data: ViatorTourListBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof viatorTourList>>,
    TError,
    { data: ViatorTourListBodyBody },
    TContext
> => {
    const mutationOptions = getViatorTourListMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Point-in-time availability & price validation for a specific date/time and traveller mix.
 * @summary Viator Tour Availability Check (v1)
 */
export const viatorAvailabilityCheck = (
    viatorAvailabilityCheckBodyBody: ViatorAvailabilityCheckBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<ViatorAvailabilityCheckSuccessResponseResponse>({
        url: `/integrations/viator/availability`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: viatorAvailabilityCheckBodyBody,
        signal,
    });
};

export const getViatorAvailabilityCheckMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof viatorAvailabilityCheck>>,
        TError,
        { data: ViatorAvailabilityCheckBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof viatorAvailabilityCheck>>,
    TError,
    { data: ViatorAvailabilityCheckBodyBody },
    TContext
> => {
    const mutationKey = ['viatorAvailabilityCheck'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof viatorAvailabilityCheck>>,
        { data: ViatorAvailabilityCheckBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return viatorAvailabilityCheck(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ViatorAvailabilityCheckMutationResult = NonNullable<
    Awaited<ReturnType<typeof viatorAvailabilityCheck>>
>;
export type ViatorAvailabilityCheckMutationBody = ViatorAvailabilityCheckBodyBody;
export type ViatorAvailabilityCheckMutationError = APIErrorResponseResponse;

/**
 * @summary Viator Tour Availability Check (v1)
 */
export const useViatorAvailabilityCheck = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof viatorAvailabilityCheck>>,
        TError,
        { data: ViatorAvailabilityCheckBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof viatorAvailabilityCheck>>,
    TError,
    { data: ViatorAvailabilityCheckBodyBody },
    TContext
> => {
    const mutationOptions = getViatorAvailabilityCheckMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Point-in-time availability & price validation for a specific date/time range.
 * @summary Viator Tour Batch Availability Check (v1)
 */
export const viatorBatchAvailability = (
    viatorBatchAvailabilityBodyBody: ViatorBatchAvailabilityBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<ViatorBatchAvailabilitySuccessResponseResponse>({
        url: `/integrations/viator/batch-availability`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: viatorBatchAvailabilityBodyBody,
        signal,
    });
};

export const getViatorBatchAvailabilityMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof viatorBatchAvailability>>,
        TError,
        { data: ViatorBatchAvailabilityBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof viatorBatchAvailability>>,
    TError,
    { data: ViatorBatchAvailabilityBodyBody },
    TContext
> => {
    const mutationKey = ['viatorBatchAvailability'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof viatorBatchAvailability>>,
        { data: ViatorBatchAvailabilityBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return viatorBatchAvailability(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ViatorBatchAvailabilityMutationResult = NonNullable<
    Awaited<ReturnType<typeof viatorBatchAvailability>>
>;
export type ViatorBatchAvailabilityMutationBody = ViatorBatchAvailabilityBodyBody;
export type ViatorBatchAvailabilityMutationError = APIErrorResponseResponse;

/**
 * @summary Viator Tour Batch Availability Check (v1)
 */
export const useViatorBatchAvailability = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof viatorBatchAvailability>>,
        TError,
        { data: ViatorBatchAvailabilityBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof viatorBatchAvailability>>,
    TError,
    { data: ViatorBatchAvailabilityBodyBody },
    TContext
> => {
    const mutationOptions = getViatorBatchAvailabilityMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Retrieve up-to-date pricing for multiple products.
 * @summary Viator Tour Batch Pricing (v1)
 */
export const viatorBatchPricing = (
    batchPricingBodyBody: BatchPricingBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<BatchPricingSuccessResponseResponse>({
        url: `/integrations/viator/batch-pricing`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: batchPricingBodyBody,
        signal,
    });
};

export const getViatorBatchPricingMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof viatorBatchPricing>>,
        TError,
        { data: BatchPricingBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof viatorBatchPricing>>,
    TError,
    { data: BatchPricingBodyBody },
    TContext
> => {
    const mutationKey = ['viatorBatchPricing'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof viatorBatchPricing>>,
        { data: BatchPricingBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return viatorBatchPricing(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ViatorBatchPricingMutationResult = NonNullable<
    Awaited<ReturnType<typeof viatorBatchPricing>>
>;
export type ViatorBatchPricingMutationBody = BatchPricingBodyBody;
export type ViatorBatchPricingMutationError = APIErrorResponseResponse;

/**
 * @summary Viator Tour Batch Pricing (v1)
 */
export const useViatorBatchPricing = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof viatorBatchPricing>>,
        TError,
        { data: BatchPricingBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof viatorBatchPricing>>,
    TError,
    { data: BatchPricingBodyBody },
    TContext
> => {
    const mutationOptions = getViatorBatchPricingMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Create a new booking for a Viator tour.
 * @summary Viator Tour Booking (v1)
 */
export const viatorBooking = (
    viatorBookingBodyBody: ViatorBookingBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<ViatorBookingSuccessResponseResponse>({
        url: `/integrations/viator/booking`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: viatorBookingBodyBody,
        signal,
    });
};

export const getViatorBookingMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof viatorBooking>>,
        TError,
        { data: ViatorBookingBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof viatorBooking>>,
    TError,
    { data: ViatorBookingBodyBody },
    TContext
> => {
    const mutationKey = ['viatorBooking'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof viatorBooking>>,
        { data: ViatorBookingBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return viatorBooking(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ViatorBookingMutationResult = NonNullable<Awaited<ReturnType<typeof viatorBooking>>>;
export type ViatorBookingMutationBody = ViatorBookingBodyBody;
export type ViatorBookingMutationError = APIErrorResponseResponse;

/**
 * @summary Viator Tour Booking (v1)
 */
export const useViatorBooking = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof viatorBooking>>,
        TError,
        { data: ViatorBookingBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof viatorBooking>>,
    TError,
    { data: ViatorBookingBodyBody },
    TContext
> => {
    const mutationOptions = getViatorBookingMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Cancel a booking created through Viator integration.
 * @summary Viator Booking Cancellation (v1)
 */
export const viatorBookingCancellation = (
    viatorBookingCancellationBodyBody: ViatorBookingCancellationBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<ViatorBookingCancellationSuccessResponseResponse>({
        url: `/integrations/viator/booking-cancellation`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: viatorBookingCancellationBodyBody,
        signal,
    });
};

export const getViatorBookingCancellationMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof viatorBookingCancellation>>,
        TError,
        { data: ViatorBookingCancellationBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof viatorBookingCancellation>>,
    TError,
    { data: ViatorBookingCancellationBodyBody },
    TContext
> => {
    const mutationKey = ['viatorBookingCancellation'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof viatorBookingCancellation>>,
        { data: ViatorBookingCancellationBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return viatorBookingCancellation(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ViatorBookingCancellationMutationResult = NonNullable<
    Awaited<ReturnType<typeof viatorBookingCancellation>>
>;
export type ViatorBookingCancellationMutationBody = ViatorBookingCancellationBodyBody;
export type ViatorBookingCancellationMutationError = APIErrorResponseResponse;

/**
 * @summary Viator Booking Cancellation (v1)
 */
export const useViatorBookingCancellation = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof viatorBookingCancellation>>,
        TError,
        { data: ViatorBookingCancellationBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof viatorBookingCancellation>>,
    TError,
    { data: ViatorBookingCancellationBodyBody },
    TContext
> => {
    const mutationOptions = getViatorBookingCancellationMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Amend an existing booking created through Viator integration.
 * @summary Viator Booking Amendment (v1)
 */
export const viatorBookingAmendment = (
    viatorBookingAmendmentBodyBody: ViatorBookingAmendmentBodyBody,
    signal?: AbortSignal,
) => {
    return customInstance<ViatorBookingAmendmentSuccessResponseResponse>({
        url: `/integrations/viator/booking-amendment`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: viatorBookingAmendmentBodyBody,
        signal,
    });
};

export const getViatorBookingAmendmentMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof viatorBookingAmendment>>,
        TError,
        { data: ViatorBookingAmendmentBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof viatorBookingAmendment>>,
    TError,
    { data: ViatorBookingAmendmentBodyBody },
    TContext
> => {
    const mutationKey = ['viatorBookingAmendment'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof viatorBookingAmendment>>,
        { data: ViatorBookingAmendmentBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return viatorBookingAmendment(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ViatorBookingAmendmentMutationResult = NonNullable<
    Awaited<ReturnType<typeof viatorBookingAmendment>>
>;
export type ViatorBookingAmendmentMutationBody = ViatorBookingAmendmentBodyBody;
export type ViatorBookingAmendmentMutationError = APIErrorResponseResponse;

/**
 * @summary Viator Booking Amendment (v1)
 */
export const useViatorBookingAmendment = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof viatorBookingAmendment>>,
        TError,
        { data: ViatorBookingAmendmentBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof viatorBookingAmendment>>,
    TError,
    { data: ViatorBookingAmendmentBodyBody },
    TContext
> => {
    const mutationOptions = getViatorBookingAmendmentMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Returns availability for an offer across a date range.
 * @summary Expedia LX Get Availability (v2.4)
 */
export const expediaGetAvailability = (
    partnerSupplierBranchId: string,
    partnerActivityId: string,
    partnerOfferId: string,
    params: ExpediaGetAvailabilityParams,
    signal?: AbortSignal,
) => {
    return customInstance<ExpediaAvailabilityResponse>({
        url: `/integrations/expedia/supplierBranches/${partnerSupplierBranchId}/activities/${partnerActivityId}/offers/${partnerOfferId}/availability`,
        method: 'GET',
        params,
        signal,
    });
};

export const getExpediaGetAvailabilityQueryKey = (
    partnerSupplierBranchId?: string,
    partnerActivityId?: string,
    partnerOfferId?: string,
    params?: ExpediaGetAvailabilityParams,
) => {
    return [
        `/integrations/expedia/supplierBranches/${partnerSupplierBranchId}/activities/${partnerActivityId}/offers/${partnerOfferId}/availability`,
        ...(params ? [params] : []),
    ] as const;
};

export const getExpediaGetAvailabilityQueryOptions = <
    TData = Awaited<ReturnType<typeof expediaGetAvailability>>,
    TError = APIErrorResponseResponse,
>(
    partnerSupplierBranchId: string,
    partnerActivityId: string,
    partnerOfferId: string,
    params: ExpediaGetAvailabilityParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof expediaGetAvailability>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getExpediaGetAvailabilityQueryKey(
            partnerSupplierBranchId,
            partnerActivityId,
            partnerOfferId,
            params,
        );

    const queryFn: QueryFunction<Awaited<ReturnType<typeof expediaGetAvailability>>> = ({
        signal,
    }) =>
        expediaGetAvailability(
            partnerSupplierBranchId,
            partnerActivityId,
            partnerOfferId,
            params,
            signal,
        );

    return {
        queryKey,
        queryFn,
        enabled: !!(partnerSupplierBranchId && partnerActivityId && partnerOfferId),
        ...queryOptions,
    } as UseQueryOptions<Awaited<ReturnType<typeof expediaGetAvailability>>, TError, TData> & {
        queryKey: QueryKey;
    };
};

export type ExpediaGetAvailabilityQueryResult = NonNullable<
    Awaited<ReturnType<typeof expediaGetAvailability>>
>;
export type ExpediaGetAvailabilityQueryError = APIErrorResponseResponse;

/**
 * @summary Expedia LX Get Availability (v2.4)
 */

export function useExpediaGetAvailability<
    TData = Awaited<ReturnType<typeof expediaGetAvailability>>,
    TError = APIErrorResponseResponse,
>(
    partnerSupplierBranchId: string,
    partnerActivityId: string,
    partnerOfferId: string,
    params: ExpediaGetAvailabilityParams,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof expediaGetAvailability>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getExpediaGetAvailabilityQueryOptions(
        partnerSupplierBranchId,
        partnerActivityId,
        partnerOfferId,
        params,
        options,
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * Creates a new sale hold (phase 1 of 2-phase commit).
 * @summary Expedia LX Create Sale (v2.4)
 */
export const expediaCreateSale = (
    partnerSupplierBranchId: string,
    expediaCreateSaleRequest: ExpediaCreateSaleRequest,
    signal?: AbortSignal,
) => {
    return customInstance<ExpediaCreateSaleResponse>({
        url: `/integrations/expedia/supplierBranches/${partnerSupplierBranchId}/sales`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: expediaCreateSaleRequest,
        signal,
    });
};

export const getExpediaCreateSaleMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof expediaCreateSale>>,
        TError,
        { partnerSupplierBranchId: string; data: ExpediaCreateSaleRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof expediaCreateSale>>,
    TError,
    { partnerSupplierBranchId: string; data: ExpediaCreateSaleRequest },
    TContext
> => {
    const mutationKey = ['expediaCreateSale'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof expediaCreateSale>>,
        { partnerSupplierBranchId: string; data: ExpediaCreateSaleRequest }
    > = (props) => {
        const { partnerSupplierBranchId, data } = props ?? {};

        return expediaCreateSale(partnerSupplierBranchId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ExpediaCreateSaleMutationResult = NonNullable<
    Awaited<ReturnType<typeof expediaCreateSale>>
>;
export type ExpediaCreateSaleMutationBody = ExpediaCreateSaleRequest;
export type ExpediaCreateSaleMutationError = APIErrorResponseResponse;

/**
 * @summary Expedia LX Create Sale (v2.4)
 */
export const useExpediaCreateSale = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof expediaCreateSale>>,
        TError,
        { partnerSupplierBranchId: string; data: ExpediaCreateSaleRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof expediaCreateSale>>,
    TError,
    { partnerSupplierBranchId: string; data: ExpediaCreateSaleRequest },
    TContext
> => {
    const mutationOptions = getExpediaCreateSaleMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Commits a previously created sale (phase 2 of 2-phase commit).
 * @summary Expedia LX Commit Sale (v2.4)
 */
export const expediaCommitSale = (
    partnerSupplierBranchId: string,
    partnerSaleId: string,
    expediaCommitSaleRequest: ExpediaCommitSaleRequest,
) => {
    return customInstance<ExpediaCommitSaleResponse>({
        url: `/integrations/expedia/supplierBranches/${partnerSupplierBranchId}/sales/${partnerSaleId}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: expediaCommitSaleRequest,
    });
};

export const getExpediaCommitSaleMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof expediaCommitSale>>,
        TError,
        { partnerSupplierBranchId: string; partnerSaleId: string; data: ExpediaCommitSaleRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof expediaCommitSale>>,
    TError,
    { partnerSupplierBranchId: string; partnerSaleId: string; data: ExpediaCommitSaleRequest },
    TContext
> => {
    const mutationKey = ['expediaCommitSale'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof expediaCommitSale>>,
        { partnerSupplierBranchId: string; partnerSaleId: string; data: ExpediaCommitSaleRequest }
    > = (props) => {
        const { partnerSupplierBranchId, partnerSaleId, data } = props ?? {};

        return expediaCommitSale(partnerSupplierBranchId, partnerSaleId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ExpediaCommitSaleMutationResult = NonNullable<
    Awaited<ReturnType<typeof expediaCommitSale>>
>;
export type ExpediaCommitSaleMutationBody = ExpediaCommitSaleRequest;
export type ExpediaCommitSaleMutationError = APIErrorResponseResponse;

/**
 * @summary Expedia LX Commit Sale (v2.4)
 */
export const useExpediaCommitSale = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof expediaCommitSale>>,
        TError,
        { partnerSupplierBranchId: string; partnerSaleId: string; data: ExpediaCommitSaleRequest },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof expediaCommitSale>>,
    TError,
    { partnerSupplierBranchId: string; partnerSaleId: string; data: ExpediaCommitSaleRequest },
    TContext
> => {
    const mutationOptions = getExpediaCommitSaleMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Releases a pending sale hold without committing.
 * @summary Expedia LX Release Sale (v2.4)
 */
export const expediaReleaseSale = (partnerSupplierBranchId: string, partnerSaleId: string) => {
    return customInstance<ExpediaReleaseSaleResponse>({
        url: `/integrations/expedia/supplierBranches/${partnerSupplierBranchId}/sales/${partnerSaleId}`,
        method: 'DELETE',
    });
};

export const getExpediaReleaseSaleMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof expediaReleaseSale>>,
        TError,
        { partnerSupplierBranchId: string; partnerSaleId: string },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof expediaReleaseSale>>,
    TError,
    { partnerSupplierBranchId: string; partnerSaleId: string },
    TContext
> => {
    const mutationKey = ['expediaReleaseSale'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof expediaReleaseSale>>,
        { partnerSupplierBranchId: string; partnerSaleId: string }
    > = (props) => {
        const { partnerSupplierBranchId, partnerSaleId } = props ?? {};

        return expediaReleaseSale(partnerSupplierBranchId, partnerSaleId);
    };

    return { mutationFn, ...mutationOptions };
};

export type ExpediaReleaseSaleMutationResult = NonNullable<
    Awaited<ReturnType<typeof expediaReleaseSale>>
>;

export type ExpediaReleaseSaleMutationError = APIErrorResponseResponse;

/**
 * @summary Expedia LX Release Sale (v2.4)
 */
export const useExpediaReleaseSale = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof expediaReleaseSale>>,
        TError,
        { partnerSupplierBranchId: string; partnerSaleId: string },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof expediaReleaseSale>>,
    TError,
    { partnerSupplierBranchId: string; partnerSaleId: string },
    TContext
> => {
    const mutationOptions = getExpediaReleaseSaleMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Returns the current status of a sale.
 * @summary Expedia LX Get Sale (v2.4)
 */
export const expediaGetSale = (
    partnerSupplierBranchId: string,
    partnerSaleId: string,
    signal?: AbortSignal,
) => {
    return customInstance<ExpediaGetSaleResponse>({
        url: `/integrations/expedia/supplierBranches/${partnerSupplierBranchId}/sales/${partnerSaleId}`,
        method: 'GET',
        signal,
    });
};

export const getExpediaGetSaleQueryKey = (
    partnerSupplierBranchId?: string,
    partnerSaleId?: string,
) => {
    return [
        `/integrations/expedia/supplierBranches/${partnerSupplierBranchId}/sales/${partnerSaleId}`,
    ] as const;
};

export const getExpediaGetSaleQueryOptions = <
    TData = Awaited<ReturnType<typeof expediaGetSale>>,
    TError = APIErrorResponseResponse,
>(
    partnerSupplierBranchId: string,
    partnerSaleId: string,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof expediaGetSale>>, TError, TData>;
    },
) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getExpediaGetSaleQueryKey(partnerSupplierBranchId, partnerSaleId);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof expediaGetSale>>> = ({ signal }) =>
        expediaGetSale(partnerSupplierBranchId, partnerSaleId, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!(partnerSupplierBranchId && partnerSaleId),
        ...queryOptions,
    } as UseQueryOptions<Awaited<ReturnType<typeof expediaGetSale>>, TError, TData> & {
        queryKey: QueryKey;
    };
};

export type ExpediaGetSaleQueryResult = NonNullable<Awaited<ReturnType<typeof expediaGetSale>>>;
export type ExpediaGetSaleQueryError = APIErrorResponseResponse;

/**
 * @summary Expedia LX Get Sale (v2.4)
 */

export function useExpediaGetSale<
    TData = Awaited<ReturnType<typeof expediaGetSale>>,
    TError = APIErrorResponseResponse,
>(
    partnerSupplierBranchId: string,
    partnerSaleId: string,
    options?: {
        query?: UseQueryOptions<Awaited<ReturnType<typeof expediaGetSale>>, TError, TData>;
    },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
    const queryOptions = getExpediaGetSaleQueryOptions(
        partnerSupplierBranchId,
        partnerSaleId,
        options,
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
}

/**
 * Creates a cancellation hold (phase 1 of 2-phase cancel).
 * @summary Expedia LX Create Sale Cancellation (v2.4)
 */
export const expediaCreateSaleCancellation = (
    partnerSupplierBranchId: string,
    partnerSaleId: string,
    expediaCreateSaleCancellationRequest: ExpediaCreateSaleCancellationRequest,
    signal?: AbortSignal,
) => {
    return customInstance<ExpediaCreateSaleCancellationResponse>({
        url: `/integrations/expedia/supplierBranches/${partnerSupplierBranchId}/sales/${partnerSaleId}/cancellation`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: expediaCreateSaleCancellationRequest,
        signal,
    });
};

export const getExpediaCreateSaleCancellationMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof expediaCreateSaleCancellation>>,
        TError,
        {
            partnerSupplierBranchId: string;
            partnerSaleId: string;
            data: ExpediaCreateSaleCancellationRequest;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof expediaCreateSaleCancellation>>,
    TError,
    {
        partnerSupplierBranchId: string;
        partnerSaleId: string;
        data: ExpediaCreateSaleCancellationRequest;
    },
    TContext
> => {
    const mutationKey = ['expediaCreateSaleCancellation'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof expediaCreateSaleCancellation>>,
        {
            partnerSupplierBranchId: string;
            partnerSaleId: string;
            data: ExpediaCreateSaleCancellationRequest;
        }
    > = (props) => {
        const { partnerSupplierBranchId, partnerSaleId, data } = props ?? {};

        return expediaCreateSaleCancellation(partnerSupplierBranchId, partnerSaleId, data);
    };

    return { mutationFn, ...mutationOptions };
};

export type ExpediaCreateSaleCancellationMutationResult = NonNullable<
    Awaited<ReturnType<typeof expediaCreateSaleCancellation>>
>;
export type ExpediaCreateSaleCancellationMutationBody = ExpediaCreateSaleCancellationRequest;
export type ExpediaCreateSaleCancellationMutationError = APIErrorResponseResponse;

/**
 * @summary Expedia LX Create Sale Cancellation (v2.4)
 */
export const useExpediaCreateSaleCancellation = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof expediaCreateSaleCancellation>>,
        TError,
        {
            partnerSupplierBranchId: string;
            partnerSaleId: string;
            data: ExpediaCreateSaleCancellationRequest;
        },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof expediaCreateSaleCancellation>>,
    TError,
    {
        partnerSupplierBranchId: string;
        partnerSaleId: string;
        data: ExpediaCreateSaleCancellationRequest;
    },
    TContext
> => {
    const mutationOptions = getExpediaCreateSaleCancellationMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Commits a previously prepared sale cancellation.
 * @summary Expedia LX Commit Sale Cancellation (v2.4)
 */
export const expediaCommitSaleCancellation = (
    partnerSupplierBranchId: string,
    partnerSaleId: string,
    cancellationCode: string,
) => {
    return customInstance<ExpediaCommitSaleCancellationResponse>({
        url: `/integrations/expedia/supplierBranches/${partnerSupplierBranchId}/sales/${partnerSaleId}/cancellation/${cancellationCode}`,
        method: 'PUT',
    });
};

export const getExpediaCommitSaleCancellationMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof expediaCommitSaleCancellation>>,
        TError,
        { partnerSupplierBranchId: string; partnerSaleId: string; cancellationCode: string },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof expediaCommitSaleCancellation>>,
    TError,
    { partnerSupplierBranchId: string; partnerSaleId: string; cancellationCode: string },
    TContext
> => {
    const mutationKey = ['expediaCommitSaleCancellation'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof expediaCommitSaleCancellation>>,
        { partnerSupplierBranchId: string; partnerSaleId: string; cancellationCode: string }
    > = (props) => {
        const { partnerSupplierBranchId, partnerSaleId, cancellationCode } = props ?? {};

        return expediaCommitSaleCancellation(
            partnerSupplierBranchId,
            partnerSaleId,
            cancellationCode,
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type ExpediaCommitSaleCancellationMutationResult = NonNullable<
    Awaited<ReturnType<typeof expediaCommitSaleCancellation>>
>;

export type ExpediaCommitSaleCancellationMutationError = APIErrorResponseResponse;

/**
 * @summary Expedia LX Commit Sale Cancellation (v2.4)
 */
export const useExpediaCommitSaleCancellation = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof expediaCommitSaleCancellation>>,
        TError,
        { partnerSupplierBranchId: string; partnerSaleId: string; cancellationCode: string },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof expediaCommitSaleCancellation>>,
    TError,
    { partnerSupplierBranchId: string; partnerSaleId: string; cancellationCode: string },
    TContext
> => {
    const mutationOptions = getExpediaCommitSaleCancellationMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Releases a pending cancellation hold.
 * @summary Expedia LX Release Sale Cancellation (v2.4)
 */
export const expediaReleaseSaleCancellation = (
    partnerSupplierBranchId: string,
    partnerSaleId: string,
    cancellationCode: string,
) => {
    return customInstance<ExpediaReleaseSaleCancellationResponse>({
        url: `/integrations/expedia/supplierBranches/${partnerSupplierBranchId}/sales/${partnerSaleId}/cancellation/${cancellationCode}`,
        method: 'DELETE',
    });
};

export const getExpediaReleaseSaleCancellationMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof expediaReleaseSaleCancellation>>,
        TError,
        { partnerSupplierBranchId: string; partnerSaleId: string; cancellationCode: string },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof expediaReleaseSaleCancellation>>,
    TError,
    { partnerSupplierBranchId: string; partnerSaleId: string; cancellationCode: string },
    TContext
> => {
    const mutationKey = ['expediaReleaseSaleCancellation'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof expediaReleaseSaleCancellation>>,
        { partnerSupplierBranchId: string; partnerSaleId: string; cancellationCode: string }
    > = (props) => {
        const { partnerSupplierBranchId, partnerSaleId, cancellationCode } = props ?? {};

        return expediaReleaseSaleCancellation(
            partnerSupplierBranchId,
            partnerSaleId,
            cancellationCode,
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type ExpediaReleaseSaleCancellationMutationResult = NonNullable<
    Awaited<ReturnType<typeof expediaReleaseSaleCancellation>>
>;

export type ExpediaReleaseSaleCancellationMutationError = APIErrorResponseResponse;

/**
 * @summary Expedia LX Release Sale Cancellation (v2.4)
 */
export const useExpediaReleaseSaleCancellation = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof expediaReleaseSaleCancellation>>,
        TError,
        { partnerSupplierBranchId: string; partnerSaleId: string; cancellationCode: string },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof expediaReleaseSaleCancellation>>,
    TError,
    { partnerSupplierBranchId: string; partnerSaleId: string; cancellationCode: string },
    TContext
> => {
    const mutationOptions = getExpediaReleaseSaleCancellationMutationOptions(options);

    return useMutation(mutationOptions);
};
